import React, { useRef, useEffect } from "react";

function handleScriptLoad(updateQuery, autoCompleteRef) {
    if (window.google){
        let autoComplete = new window.google.maps.places.Autocomplete(
            autoCompleteRef.current,
            { types: [], componentRestrictions: { country: "ng" } }
        );
        autoComplete.setFields(["address_components", "formatted_address", "geometry"]);
        autoComplete.addListener("place_changed", () =>
            handlePlaceSelect(autoComplete, updateQuery)
        );
    }
}

async function handlePlaceSelect(autoComplete, updateQuery) {
    const addressObject = autoComplete.getPlace();
    const query = addressObject.formatted_address;
    updateQuery(query);
}

function SearchLocationInput({query, setQuery}) {
    const autoCompleteRef = useRef(null);
    useEffect(() => {
        handleScriptLoad(setQuery, autoCompleteRef)
    }, [setQuery])

    return (
        <div className="search-location-input">
            <input
                type="text"
                className="text-sm block w-full rounded py-2 pl-8 px-2 focus:outline-none text-gray-700"
                ref={autoCompleteRef}
                onChange={e => {
                    setQuery(e.target.value)
                    handleScriptLoad(setQuery, autoCompleteRef)
                }}
                placeholder="Enter address"
                value={query}
            />
        </div>
    );
}

export default SearchLocationInput;